import { render, staticRenderFns } from "./ManagerDetailsAllTabs.vue?vue&type=template&id=6573dcd7"
import script from "./ManagerDetailsAllTabs.vue?vue&type=script&lang=js"
export * from "./ManagerDetailsAllTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports